import axios from 'axios';

export const unplannedNotifictaionService = {
    showUnplannedNotification: async () => {
        let notificationCount;

        try {
            const response = (await axios.get(
                `/dashboard/orders/alternatives/notifications`,
                {
                    headers: {'X-Requested-With': 'XMLHttpRequest'}
                }
            ));

            notificationCount = response?.data?.count;
        } catch(e) {}

        if (!notificationCount) {
            return;
        }
    
        const $accountButton = $('.js_account-control');
        $accountButton.find('.order-notice-quantity.m_account').remove();
    
        $accountButton.find('.svg-icon.icon-account').each((i, item) => {
            $(`<span class="order-notice-quantity m_account">${notificationCount}</span>`).insertAfter($(item));
        });
    
        $('.js_account-menu-orders').each((i, item) => {
            $(item).html(`Mijn bestellingen <span class="order-notice-quantity">${notificationCount}</span>`)
        })
    },
}